import { render, staticRenderFns } from "./paragraphs.vue?vue&type=template&id=879e2d38&lang=html&"
import script from "./paragraphs.vue?vue&type=script&lang=js&"
export * from "./paragraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports